// extracted by mini-css-extract-plugin
export default {"parent":"parent--q35eO","child":"child--q35eO"};